import React from "react";
import { Card, CardBody } from "reactstrap";

const StatisticCard = ({ title, statistic, statistic2, color, double, description, description2 }) => {
    return (
        <Card
            className="statistic--card h-100"
            style={{
                borderTop: `6px solid ${color}`,
                borderLeft: 'none',
                borderRadius: '12px',
                boxShadow: '0 2px 10px rgba(0,0,0,0.08)'
            }}
        >
            <CardBody className="p-4">
                {!double ? (
                    <React.Fragment>
                        <h6 className="text-primary font-weight-bold mb-3" style={{ fontSize: '0.85rem', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                            {title}
                        </h6>
                        <h1 className="font-weight-bold mb-0 display-2" style={{ color: '#2c3e50', fontSize: '3.5rem' }}>
                            {statistic}
                        </h1>
                    </React.Fragment>
                ) : (
                    <div className="d-flex justify-content-between align-items-center">
                        <div className="text-center flex-fill">
                            <h6 className="text-primary font-weight-bold mb-2" style={{ fontSize: '0.75rem', textTransform: 'uppercase' }}>
                                {title}
                            </h6>
                            <h2 className="font-weight-bold mb-1 display-3" style={{ color: '#2c3e50', fontSize: '2.5rem' }}>
                                {statistic}
                            </h2>
                            <small className="text-muted">{description}</small>
                        </div>
                        <div className="text-center flex-fill border-left pl-3">
                            <h2 className="font-weight-bold mb-1 display-3" style={{ color: '#2c3e50', fontSize: '2.5rem' }}>
                                {statistic2}
                            </h2>
                            <small className="text-muted">{description2}</small>
                        </div>
                    </div>
                )}
            </CardBody>
        </Card>
    );
};

export default StatisticCard;
